import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { AddSupplierNumberModal } from "./AddSupplierNumberModal";
import { useState } from "react";
import useTranslation from "../../../../../../packages/locales/translations/util/useTranslation";

export const SupplierNumber = () => {
  const { t } = useTranslation();
  const [showAddSupplierNumberModal, setShowAddSupplierNumberModal] =
    useState(false);

  const [supplierNumber, setSupplierNumber] = useState<string>("");
  const handleAddSupplierNumberClick = () => {
    setShowAddSupplierNumberModal(true);
  };

  const handleCloseModal = () => {
    setShowAddSupplierNumberModal(false);
  };
  return (
    <>
      <FixaListViewItem
        size="medium"
        control="navigational"
        controlIcon="chevronRight"
        inset
        onClick={handleAddSupplierNumberClick}
        id="supplier-number"
        data-testid="supplier-number-item"
        title={
          <FixaText textStyle="Heading.XS">
            {t("supplierNumberString")}
          </FixaText>
        }
        description={supplierNumber}
      ></FixaListViewItem>
      <AddSupplierNumberModal
        showModal={showAddSupplierNumberModal}
        handleClose={handleCloseModal}
        supplierNumber={supplierNumber}
        onSubmit={(newSupplierNumber) => {
          setSupplierNumber(newSupplierNumber);
          handleCloseModal();
        }}
      />
    </>
  );
};
